import React, { forwardRef, HtmlHTMLAttributes, memo, ReactElement, ReactNode } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";

export type EmptyStateSize = "sm" | "md" | "lg";

export type EmptyStateProps = HtmlHTMLAttributes<HTMLDivElement> & {
  icon?: ReactElement,
  size?: EmptyStateSize
  header?: ReactNode
  supportingText?: ReactNode
  headerClassName?: string
  iconClassName?: string
  supportingTextClassName?: string
  actionsClassName?: string
};

export const EmptyState = memo(forwardRef<HTMLDivElement, EmptyStateProps>((
  {
    children,
    size,
    header,
    supportingText,
    className,
    headerClassName,
    supportingTextClassName,
    actionsClassName,
    iconClassName,
    icon,
    ...props
  },
  ref,
) => {
  return (
    <div
      className={classNames(
        styles.root,
        styles[size as keyof typeof styles],
        className,
      )}
      {...props}
      ref={ref}
    >
      {
        icon &&
        <div className={classNames(styles.icon, iconClassName)}>{icon}</div>
      }
      {
        header &&
        <h4 className={classNames(styles.header, headerClassName)}>{header}</h4>
      }
      {
        supportingText &&
        <div className={classNames(styles.supportingText, supportingTextClassName)}>{supportingText}</div>
      }
      {
        children &&
        <div className={classNames(styles.actions, actionsClassName)}>
          {children}
        </div>
      }
    </div>
  );
}));